import InputDate from './view/desktop';
export default InputDate;
